/**
 * WebKit (Safari iOS, в т.ч. PWA/standalone): в глобале нет биндинга `Notification` —
 * выражения `Notification.permission` / `new Notification()` дают ReferenceError и валят React.
 * Всегда берём API только с window и после проверки.
 */
export function getNotificationApi() {
  if (typeof window === 'undefined') return null;
  try {
    return window.Notification != null ? window.Notification : null;
  } catch {
    return null;
  }
}
